<template>
    <JobProgress v-model="downloadJobState" v-on:done="$emit('job-done')" :job_id="asyncJobId">
        <template v-slot:progress>
            <v-progress-circular
                v-if="downloadJobState==='running'"
                indeterminate
                class="mr-2"              
                color="primary"
            ></v-progress-circular>
        </template>
        <template v-slot:done>
            <v-progress-circular
                v-if="loading"
                indeterminate
                class="mr-2"              
                color="primary"
            ></v-progress-circular>
        </template>
        <template v-slot:quiet>
            <v-menu
                v-if="!loading && show_actions_selector"
                v-model="action_menu"
                :close-on-click="true"
                :close-on-content-click="false"
                offsetY
                :nudge-left="69"
                class="menu"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="disabled"
                        outlined 
                        text 
                        class="primary-border"
                    >
                        Acciones
                        <v-icon v-if="action_menu">mdi-menu-up</v-icon>
                        <v-icon v-else>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-list id="account-menu" class="action-menu-list">
                    <v-list-item-group color="primary">
                        <div v-for="(item, index) in actions['action']" :key="index">
                            <v-list-item
                                @click="!item.disabled && doAction(item.id)"
                                :class="{highlighted: item.highlighted, list: true, 'v-list-item--disabled': item.disabled}"
                                :disabled="item.disabled"
                            >
                                <v-list-item-title class="list-title">
                                    {{item.name}}
                                    <!-- {{ Object(groups).keys().includes(item.name)?groups[item.name]:item.name }} -->
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-list-item-group>
                    <v-list-group
                        v-for="(item, index) in Object.keys(getActionsGroups)"
                        :key="index"                            
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item class="pa-0">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{groups[item]}}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>  
                        <v-list-item
                            v-for="(subItem, index2) in getActionsGroups[item]"
                            :key="index2"                
                            class="pa-0"
                        >
                            <v-list-item
                                @click="doAction(subItem.id)"
                                :class="{highlighted: subItem.highlighted, list: true}"
                            >
                                <v-list-item-title class="list-title">{{ subItem.name }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item>
                    </v-list-group>
                </v-list>
            </v-menu>
        </template>
    </JobProgress>
</template>

<script>
    import JobProgress from '../components/JobProgress.vue';
    import { mapFields } from 'vuex-map-fields';
    export default {
        name: 'ActionSelector',
        components: {
            JobProgress,
        },
        props: {
            actions: {
                type: [Array, Object],
                required: true,
            },
            groups: {
                type: Object,
                required: false, 
                default: {},
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            itemKey: {
                type: String,
                required: false,
                default: 'id',
            },
            itemText: {
                type: String,
                required: false,
                default: 'name',
            },
            loading: {
                type: Boolean,
                required: false,
                default: false
            },
            store: {
                type: String,
                required: false,
                default: '',
            },
            show_actions_selector: {
                type: Boolean,
                required: false,
                default: true,
            },

        },
        computed: {
            ...mapFields({
                downloadJobState: 'downloadJobState',
                asyncJobId: 'asyncJobId',
            }), 
            getActionsGroups() {
                let action_groups = {};
                let keys = Object.keys(this.actions);
                for (let i in keys) {
                    if (!['action', 'btn', 'icon_btn'].includes(keys[i])) {
                        action_groups[keys[i]] = this.actions[keys[i]];
                    }
                }
                return action_groups;
            },
        },
        data() {
            return {
                action: undefined,
                send_filters: false,

                action_menu: false,
            };
        },
        methods: {
            doAction(action_id) {
                this.action_menu = false;
                this.$emit('selected-action', action_id);
            }
        }
    }
</script>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
</style>

<style>
.action-menu-list {
  max-height: 81vh !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  margin-top: 8px !important;
}
</style>